// @flow

// Global objects
import $ from "../vendor/jquery";
import bootbox from "../vendor/bootbox";

// Global grobot objects
import Settings from "./Settings";
import WagonConf from "./WagonConf";
import Graph from "./Graph";
import Alarms from "./Alarms";

// Global functions
import global, {limit_strlen} from "./Global";
import {activateMenuItem, getProductCode, htmlEncode, is_numeric, jsonAjax} from "../util";
import {convert_data_row} from "./Drow";
import type {
    ConvertedMeasurementType, IntegerType,
    MeasurementType,
    ProductVersionsResultType,
    ProductVersionsType,
    WagonsResultType
} from "../model";
import AppConfig from "../config";
import t from "../trans";
import Legacy from "../Legacy";
import Popup from "../Popup";
import ProductTransformer from "../ProductTransformer";
import SettingsStore from "../stores/SettingsStore";

/**
 * Vagunite lehte haldav moodul
 *
 */
class Wagons {
    productTransformer: ?ProductTransformer = null;

    /**
     * @private
     * @type {?Wagons}
     */
    static wagonsInstance: ?Wagons = null;

    /**
     * @returns {Wagons}
     */
    static getInstance(): Wagons {
        if (Wagons.wagonsInstance == null) Wagons.wagonsInstance = new Wagons();
        return Wagons.wagonsInstance;
    }

    constructor() {
        // @formatter:off
        this.grid_cols = [
            // suurus px,
            // väli,
            // pealkiri,
            // kas esineb lihtsas UIs: 0 või null - mõlemal juhul, 1 - ainult keerukas, 2 - ainult lihtne
            // kas tuleb joonistada vertikaalne eraldusjoon enne antud veergu true/false
            [30, 'wagon', 'wgn', 1, false],
            [60, 'xskeleton', 'skeleton', 1, false],
            [60, 'skeleton', 'skeleton', 2, false],
            [50, 'xcode', 'code', 1, false],
            [50, 'code', 'code', 2, false],
            [50, 'description1', 'product', 1, false],
            [-1, 'description2', 'description', 0, false],
            [40, 0, 'P', 0, true],
            [40, 'edge', 'edg', 1, true],
            [40, 'measure', 'msr', 1, false],
            [60, 'fedge', 'fedg', 1, false],
            // [40, 'repeat', 'rep', 1, false]
            //  [40, 'wagon', 'wagon', false],
        ];
        // @formatter:on
        /**
         * Base URL for wagons query
         * @type {string}
         */
        this.wagon_urlbase = AppConfig.BASE_URL + "/wagons/";
        this.min_wagon_urlnr = 1;
        this.wagon_load_count = 0;

        this.edge_btn = this.edge_btn.bind(this);
        this.fedge_btn = this.fedge_btn.bind(this);
    }

    /**
     * Vagunite lehe tekitamine
     */
    make_wagons_page() {
        let settings = Settings.getInstance();
        this.productTransformer = new ProductTransformer(SettingsStore.getProductConfig());

        this.remember_manual_mode_bar();
        global.menu_translate();
        global.clear_old_page();

        $("#intop2").css("margin-top", "");
        $("#intop2").css("margin-left", "");

        if (settings.isManualModeAllowed() && settings.isManualMode()) {
            this.make_manual_mode_bar();
        }

        // Tekita vagunite tabel
        this.make_grid();
        activateMenuItem("wagons");

        if (settings.isManualModeAllowed() && settings.isManualMode()) {
            this.restore_manual_mode_bar();
            this.init_manual_mode_bar();
        }

        this.productTransformer = null;
    }

    /**
     * Vagunite tabeli tekitamine vagunite lehe sisse
     * @returns {String}
     */
    make_grid(): string {
        let settings = Settings.getInstance();
        let s = "<table id='gridtable'>";

        // Vagunite tabeli päis
        s += this.make_grid_titlerow();

        if (settings.isManualMode() && global.grid_data[0]) {
            // Tekitame manuaalse mõõtmise rea:
            //analyze_drow(global.grid_data[0]);
            s += this.make_grid_row(0, global.grid_data[0]);
            // s += '<tr class="gridtr gridtr0"><td class="gridtd gridtd_1" colspan="'+this.grid_cols.length+'"></td></tr>\n';
        }

        for (let y = 1; y <= settings.getWagonCount(); y++) {
            let drow = {};
            if (global.grid_data.length > y && global.grid_data[y]) {
                drow = global.grid_data[y];
                //analyze_drow(drow);
            }

            // Vagunite tabeli rida
            s += this.make_grid_row(y, drow);

        }

        s += "</table>";
        global.force_correct = false;
        $("#content").html(s);
    }

    /**
     * Vagunite tabeli päisrea tekitamine.
     * @returns {String}
     */
    make_grid_titlerow(): string {
        let settings = Settings.getInstance();
        let s = "";
        let isSimple = settings.isSimpleUi();

        s += "<tr class='gridtr gridtrhead'>\n";

        let nominalNames = this.productTransformer.getOrderedNominalNames();

        for (let x = 0; x < this.grid_cols.length; x++) {
            // loop over cols
            let cclasses = "";
            let cstyle = "";
            let cvalue = "";
            let colmeta = this.grid_cols[x];

            if ((colmeta[3] == 2 && !isSimple) || (colmeta[3] == 1 && isSimple)) continue;

            if (colmeta) {
                if (colmeta[0] > 0) cstyle = "width: " + colmeta[0] + "px;";
                cclasses = "gridtd_" + colmeta[1];
                if (is_numeric(colmeta[1]) || colmeta[1] == 'wagon') {
                    cclasses += " numeric";
                }
                if (colmeta[1] !== 0 && colmeta[4]) cclasses += " gridthsep";
                cvalue = t(colmeta[2]);
            }
            if (!cvalue && cvalue !== 0) cvalue = "";

            if (colmeta[1] == 0) {
                // P1 - P9/P15
                let showCenter = settings.showOnlyCenterPoints();
                let first = true;
                for (let i = 1; i <= settings.getMeasurementLineCount() * 3; i++) {
                    if (showCenter && (i % 3 != 2)) continue;
                    s += this.make_grid_titlerow_td(cclasses + (first ? " gridthsep" : ""), cstyle, cvalue + "" + i);
                    first = false;
                }

                // P300 - P50
                first = true;
                for (let i = settings.getCenterAddPoints() - 1; i >= 0; i--) {
                    let pName = (i + 1) * 50;
                    s += this.make_grid_titlerow_td(cclasses + (first ? " gridthsep" : ""), cstyle, cvalue + "" + pName);
                    first = false;
                }

                // ANGLE
                s += this.make_grid_titlerow_td(cclasses, cstyle, t("angle"));

                // H1 - H5
                first = true;
                cvalue = t("H");
                for (let i = 0; i < settings.getHudPoints(); i++) {
                    s += this.make_grid_titlerow_td(cclasses + (first ? " gridthsep" : ""), cstyle, cvalue + "" + (i+1));
                    first = false;
                }

            } else s += this.make_grid_titlerow_td(cclasses, cstyle, cvalue);
        }
        s += "</tr>\n";
        return s;
    }

    make_grid_titlerow_td(cclasses: string, cstyle: string, cvalue: string): string {
        return "<td class='gridheadtd " + cclasses + "' style='" + cstyle + "'>" + cvalue + "</td>";
    }

    /**
     * Vagunite tabeli ühe vagunirea tekitamine.
     * @param y Vagunirea number (algusega 1st, st 1. vaguni järjekorranumber on 1)
     * @param drow Antud vaguni mõõtmisinfo struktuur (massiivi global.grid_data vastava rea element)
     * @returns {String} Koostatud tabeli rida
     */
    make_grid_row(y: number, drow: ConvertedMeasurementType): string {
        let settings = Settings.getInstance();
        let isSimple = settings.isSimpleUi();

        let rclasses = "gridtr" + y;

        if (y == 0) rclasses += " manual_row";

        if (!isSimple) {
            if (y == global.current_wagon) rclasses += " current_row";  // Oranži värvi rida
            if (this.isBendingWagon(y)) rclasses += " current_row_14";                // Punast värvi rida
            if (this.isLoadingWagon(y)) rclasses += " current_row_31";                // Rohelist värvi rida
        }

        let s = "";
        for (let x = 0; x < this.grid_cols.length; x++) {
            // loop over cols
            let colmeta = this.grid_cols[x];

            if ((colmeta[3] == 2 && !isSimple) || (colmeta[3] == 1 && isSimple)) continue;
            if (colmeta[1] == 0) {
                // P-punktid:
                let showCenter = settings.showOnlyCenterPoints();

                // P1 - P9/P15
                let i = 0;
                let first = true;
                for (; i < settings.getMeasurementLineCount() * 3; i++) {
                    if (showCenter && (i % 3 != 1)) continue;
                    s += this.make_grid_col(y, drow, i, colmeta[0], (first ? colmeta[4] : false));
                    first = false;
                }

                // P300 - P50
                let centerPoints = settings.getCenterAddPoints();
                first = true;
                for (let j = centerPoints - 1; j >= 0; j--) {
                    s += this.make_grid_col(y, drow, i + j, colmeta[0], (first ? colmeta[4] : false));
                    first = false;
                }
                i += centerPoints;

                // ANGLE
                s += this.make_grid_col(y, drow, "angle", colmeta[0], false);

                // HUD1 - HUD5
                first = true;
                for (let j = 0; j < settings.getHudPoints(); j++) {
                    s += this.make_grid_col(y, drow, i + j, colmeta[0], (first ? colmeta[4] : false));
                    first = false;
                }
            } else
                s += this.make_grid_col(y, drow, colmeta[1], colmeta[0], colmeta[4]);
        }

        return "<tr class='gridtr " + rclasses + "'>\n" + s + "</tr>\n";
    }

    isLoadingWagon(y: number): boolean {
        return this.isWagonAtOffset(y, Settings.getInstance().getWagonOffsetLoading());
    }

    isBendingWagon(y: number): boolean {
        return this.isWagonAtOffset(y, Settings.getInstance().getWagonOffsetBending());
    }

    isWagonAtOffset(wagonNo: number, offset: number): boolean {
        if (offset == 0) return false;

        let wagonCount = Settings.getInstance().getWagonCount();
        let offsetWagonNo = global.current_wagon + offset;
        if (offsetWagonNo < 0) offsetWagonNo += wagonCount;
        else if (offsetWagonNo > wagonCount) offsetWagonNo -= wagonCount;
        return offsetWagonNo === wagonNo;
    }

    /**
     *
     * @param {number} y
     * @param {ConvertedMeasurementType} drow
     * @param {string} columnName
     * @param {number} width
     * @param {boolean} colsep
     * @returns {string}
     */
    make_grid_col(y: number, drow: ConvertedMeasurementType, columnName: string | number, width: number, colsep: boolean): string {
        let wagonConf: WagonConf = WagonConf.getInstance();
        let tmp;
        let cvalue = "";
        let cstyle = "";
        let cclasses = "";

        if (colsep) cclasses = "gridsep";

        if (!drow || !drow.required) {
            cclasses += " gridtd";
            return '<td class="'+cclasses+'"></td>';
        }

        if (width > 0) cstyle = "width: " + width + "px;";
        else cstyle = "";

        cclasses += " gridtd_" + columnName;
        if (is_numeric(columnName) || columnName == 'wagon' || columnName == 'angle') {
            cclasses += " numeric";
        }

        // Is content clickable?
        let clickable = false;

        if (is_numeric(columnName)) {
            if (drow.required && drow.required[columnName] != null && drow.required[columnName].length > 0 && drow.required[columnName][0] != null && drow.analyzed && drow.analyzed[columnName]) {
                let cstatus = "";
                try {
                    if (global.gridShowErr) cvalue = drow["analyzed"][columnName][0];
                    else {
                        cvalue = drow["analyzed"][columnName][2];
                        cvalue = (Math.round(cvalue)) / 10;
                    }
                    // AA: -100 is a result of missing data; TODO: raw data should be set null earlier
                    if (cvalue == -100) cvalue = "";

                    cstatus = drow["analyzed"][columnName][1];
                    // if ((columnName % 3 == 1) && (cvalue || cvalue === 0)) {
                    if (ProductTransformer.isCenterPoint(drow.lineinfo[columnName][1].substring(0, 1)) ||
                        drow.lineinfo[columnName][2]) {
                        cclasses += " gridtd_imp ";
                    } // else cclasses+=" gridtd_unimp ";
                } catch (e) {
                    cstatus = "";
                    Legacy.debug("catched 2: " + e);
                    //Legacy.debug("colmeta 1: "+columnName);
                    //Legacy.debug("drow[analyzed]: "+drow["analyzed"]);
                }
                cclasses += " row_status_" + cstatus;
            } else {
                /* df = "" */
            }
        } else if (columnName == "angle") {
            if (drow.angles && drow.angles.length > 0 && drow.angles[0].length > 0 && drow.angles[0][0] != null && drow.analyzed_angles && drow.analyzed_angles.length > 0) {
                if (global.gridShowErr) cvalue = drow["analyzed_angles"][0][0];
                else {
                    cvalue = drow["analyzed_angles"][0][2];
                    cvalue = (Math.round(cvalue)) / 10;
                }
                // AA: -100 is a result of missing data; TODO: raw data should be set null earlier
                if (cvalue == -100) cvalue = "";

                let cstatus = drow["analyzed_angles"][0][1];
                cclasses += " row_status_" + cstatus;
            }
        } else if (columnName == "wagon") {
            //cvalue=drow[columnName]+1;
            //cvalue=drow[columnName];
            if (y == "0") cvalue = t("manual");
            else cvalue = y;
        } else if (columnName == "skeleton") {
            // Mitteklikitav painutusraami number:
            //cvalue = "" + wagonConf.getRaamiNr(y) + "\n";
            cvalue = "" + (drow["skeleton"] == null ? "" : drow["skeleton"]) + "\n";
        } else if (columnName == "xskeleton") {
            // Painutusraami number on eraldi klikitav - sellega tuleb popup raami numbri muutmiseks:
            //var raamiNr = wagonConf.getRaamiNr(y) + "";
            let raamiNr = (drow["skeleton"] == null ? "" : drow["skeleton"]);
            cvalue = '<button class="btn btn-default btn-xs btn-block sbtn" type="submit" id="skeleton' + y + '" onclick="wagons.change_skeleton(' + y + ')">' + raamiNr + '</button>\n';
            clickable = true;
        } else if (columnName == "code") {
            // Lihtne koodi väli
            cvalue = (drow.codeVariant == null ? "" : drow.codeVariant);
            if (cvalue === undefined) cvalue = "";
        } else if (columnName == "xcode") {
            // Koodi väli on link, mis avab koodi versiooni sisestamise:
            let codeVariant = this.getKoodVariant(y);
            let color = "";
            if (codeVariant != drow["codeVariant"]) color = ';color: red';
            cvalue = '<button class="btn btn-xs btn-link" id="code' + y + '" onclick="wagons.change_code(' + y + ')" style="font-size: 14px' + color + '">' + (codeVariant == null ? "" : codeVariant) + '</button>\n';
            clickable = true;
        } else if (columnName == "edge") {
            if (wagonConf.isServaotsing(y)) tmp = "active";
            else tmp = "passive";
            //cvalue="<button class=\"btn btn-default btn-xs measurebtn mbtn "+tmp+"\" id='measure"+y+"' data-toggle='button' ";
            cvalue = "<button class=\"btn btn-default btn-xs measurebtn mbtn " + tmp + "\" id='edge" + y + "' ";
            cvalue += "onclick=\"wagons.edge_btn(" + y + ")\">";
            cvalue += "<span class='btntxt' style='text-align:center;'>&nbsp;</span>";
            cvalue += "</button>\n";
            clickable = true;
        } else if (columnName == "fedge") {
            // Forced edge detection
            if (wagonConf.isForcedServaotsing(y)) tmp = "active";
            else tmp = "passive";
            //cvalue="<button class=\"btn btn-default btn-xs measurebtn mbtn "+tmp+"\" id='measure"+y+"' data-toggle='button' ";
            cvalue = "<button class=\"btn btn-default btn-xs measurebtn mbtn " + tmp + "\" id='fedge" + y + "' ";
            cvalue += "onclick=\"wagons.fedge_btn(" + y + ")\">";
            cvalue += "<span class='btntxt' style='text-align:center;'>&nbsp;</span>";
            cvalue += "</button>\n";
            clickable = true;
        } else if (columnName == "measure") {
            let disabled = " ";
            //if (wagonConf.isServaotsing(y)) disabled = "disabled='disabled' ";
            if (wagonConf.isMootmine(y)) tmp = "active";
            else tmp = "passive";
            //cvalue="<button class=\"btn btn-default btn-xs measurebtn mbtn "+tmp+"\" id='measure"+y+"' data-toggle='button' ";
            cvalue = "<button class=\"btn btn-default btn-xs measurebtn mbtn " + tmp + "\" id='measure" + y + "' " + disabled;
            cvalue += "onclick=\"wagons.measure_btn(" + y + ")\">";
            cvalue += "<span class='btntxt' style='text-align:center;'>&nbsp;</span>";
            cvalue += "</button>\n";
            clickable = true;
        } else if (columnName == "repeat") {
            let disabled = " ";
            //if (wagonConf.isServaotsing(y) || !wagonConf.isMootmine(y)) disabled = "disabled='disabled' ";
            if (!wagonConf.isMootmine(y)) disabled = "disabled='disabled' ";
            //cvalue="<input type='checkbox' onclick='alert('"+y+")' id='repeat'"+y+"' checked>";
            // cvalue="<button class=\"btn btn-default btn-xs measurebtn mbtn "+tmp+"\" id='repeat"+y+"' data-toggle='button' ";
            cvalue = "<button class=\"btn btn-default btn-xs measurebtn mbtn active\" id='repeat" + y + "' " + disabled;
            cvalue += "onclick=\"wagons.repeat_btn(" + y + ")\">";
            cvalue += "<span class='btntxt' style='text-align:center;'>&nbsp;</span>";
            cvalue += "</button>\n";
            clickable = true;
        } else if (columnName == "description1" && drow) {
            cvalue = limit_strlen(drow[columnName], 13);
        } else if (columnName == "description2" && drow) {
            cvalue = limit_strlen(drow[columnName], 40);
        } else if (drow) {
            cvalue = drow[columnName];
        }

        let s = "<td class='gridtd " + cclasses + "' style='" + cstyle + "' ";
        if (!clickable) s += "onclick='graph.goto_graph_page(" + y + ")'";
        s += ">" + cvalue + "</td>";
        return s;
    }

    remember_manual_mode_bar() {
        let settings = Settings.getInstance();
        let val = $('#productNo').val();
        if (val === undefined) val = "";
        settings.setManualMeasuringTooteKood(val);
    }

    restore_manual_mode_bar() {
        let settings = Settings.getInstance();
        let val = settings.getManualMeasuringTooteKood();
        if (val === "0") val = "";
        $('#productNo').val(val);
    }

    make_manual_mode_bar() {
        let s = "";

        $("#topy").css("height", "40px");
        // $("#intop2").css("margin-top", "10px");
        $("#intop2").css("margin-left", "40px");

        s = this.make_mode_buttons();
        $("#intop2").html(s);
        $("#m_start").on('click', function () {
            this.start_measuring();
        }.bind(this));
    }

    init_manual_mode_bar() {
        let settings = Settings.getInstance();
        // let row = global.grid_data[0];

        if (settings.isMeasuringInProgress() || settings.isManualMeasuringRequested())
            this.measuring_started(settings.getManualMeasuringTooteKood());
        else
            this.measuring_finished(settings.getManualMeasuringTooteKood());
    }

    make_mode_buttons(): string {
        let s = '<form class="form-inline" onsubmit="return false;"><div class="row" style="display: flex; align-items: center">';
        s += '<div class="form-group col-md-5"><label>' + t('Manual measuring mode') + '</label></div>';
        s += '<div class="form-group col-md-3"><input type="text" size="10" class="form-control" id="productNo" placeholder="' + htmlEncode(t('code')) + '"></div>';
        s += '<div class="form-group col-md-4"><button type="submit" class="btn btn-primary" autocomplete="off" id="m_start">' + htmlEncode(t("Start measurement")) + '</button></div>';
        s += '</div></form>';
        return s;
    }

    /**
     * NB! Vale "this" väärtus?
     */
    start_measuring() {
        let codeVariant = $('#productNo').val();

        if ($('#m_start').hasClass('btn-danger')) {
            // Katkestame:
            codeVariant = "0";
            this.measuring_finished();
        } else {
            // Alustame mõõtmist:
            if (!codeVariant || codeVariant.trim() === "") {
                Popup.show_err(t("Please enter product code!"));
                $('#productNo').val('');
                return;
            }
            this.measuring_started();
        }
        jsonAjax({
            type: 'POST',
            url: AppConfig.BASE_URL + "/manualMeasuring",
            data: {kood: codeVariant},
            success: function () {
            }
        });
    }

    measuring_finished(tooteKood: string) {
        $('#productNo').prop('disabled', false);
        $('#m_start').removeClass('btn-danger').addClass('btn-primary').html(htmlEncode(t('Start measurement')));
    }

    measuring_started(tooteKood: string) {
        $('#productNo').prop('disabled', true);
        $('#m_start').removeClass('btn-primary').addClass('btn-danger').html(htmlEncode(t('Cancel measurement')));
    }

    /**
     * Returns point indexes in order as needed to show in UI
     * @returns {Number[]}
     */
    getPointNumbers(): Array<number> {
        let settings = Settings.getInstance();
        let points = [];
        let i = 0;
        // P1 - P9/P15
        for (; i < settings.getMeasurementLineCount() * 3; i++) {
            points.push(i);
        }
        // P300 - P50
        for (let j = settings.getCenterAddPoints() - 1; j >= 0; j--) {
            points.push(i + j);
        }
        // H1 - H5
        i = points.length;
        for (let j = 0; j < settings.getHudPoints(); j++) {
            points.push(i + j);
        }
        return points;
    }

    /**
     * Uuendab hetkel käsil oleva vaguni info
     */
    wagon_update() {
        let settings = Settings.getInstance();
        this.load_wagon();
        settings.load_settings();
    }

    /**
     * Uuendab kõigi vagunite info
     */
    wagon_update_all() {
        let settings = Settings.getInstance();
        this.wagon_load_count = 0;
        global.load_conf();
        for (let i = this.min_wagon_urlnr; i <= settings.getWagonCount(); i++) {
            this.load_wagon(i);
        }
    }

    load_wagon(nr: ?number) {
        if (nr != null && nr <= 0) {
            // Wagon not defined. Clear current info:
            this.wagoncall(null, nr);
            return;
        }
        let settings = Settings.getInstance();
        let wagon : string = (nr == null ? (settings.isManualMode() ? "manual" : "current") : nr.toString());
        let wurl = this.wagon_urlbase + wagon;
        // Legacy.debug("loading " + wurl);
        jsonAjax({
            type: "GET",
            url: wurl,
            success: function (data: WagonsResultType) {
                if (wagon === "current") this.currentwagoncall(data);
                else if (wagon === "manual") this.manualwagoncall(data);
                else this.wagoncall(data, nr);
            }.bind(this)
        });
    }

    currentwagoncall(data: WagonsResultType) {
        let settings = Settings.getInstance();
        this.productTransformer = new ProductTransformer(SettingsStore.getProductConfig());
        let graph = Graph.getInstance();

        Legacy.debug("currentwagoncall: current");
        if (data && data.wagonsResult) {
            // Legacy.debug(data.wagonsResult.kirjeldus1 + " " + data.wagonsResult.vaguni_number);
            let nrow = data.wagonsResult;
            let wn = nrow.vaguni_number;
            let orow = global.original_grid_data[wn] || {};
            let cnrow = convert_data_row(nrow);
            global.original_grid_data[wn] = nrow;
            global.grid_data[wn] = cnrow;
            // let updated = false;
            let old_cw = global.current_wagon;
            global.current_wagon = wn;
            if (wn || wn === 0) {
                if (!nrow.algus_aeg ||
                    nrow.algus_aeg !== orow.algus_aeg ||
                    nrow.lopp_aeg !== orow.lopp_aeg ||
                    old_cw !== wn) {
                    // updated = true;
                    Legacy.debug("updated current");
                    if (settings.isNoWagons() && nrow.algus_aeg !== orow.algus_aeg && $("#wagons_li").hasClass("active")) {
                        // Kui mõõtmise algusaeg erineb vanal ja uuel kirjel, siis tuleb kõik vagunid sisse laadida:
                        this.wagon_update_all();
                    } else {
                        if ($("#wagons_li").hasClass("active")) {
                            Legacy.debug("updated current row wagons page: new time");
                            this.make_grid();
                        } else if ($("#graph_li").hasClass("active")) {
                            Legacy.debug("updated graph page: new time");
                            if (global.current_shown_wagon == global.current_wagon) {
                                let status = $("#rawb").hasClass('active');
                                graph.make_graph_page();
                                if (status) graph.raw_toggle();
                            }
                        }
                    }
                }
            }
            // handle error showing
            this.handleError(cnrow.error);
        }
        this.productTransformer = null;
    }

    manualwagoncall(data: WagonsResultType) {
        Legacy.debug("manualwagoncall: manual");
        this.productTransformer = new ProductTransformer(SettingsStore.getProductConfig());

        let graph = Graph.getInstance();
        if (data && data.wagonsResult) {
            // Legacy.debug(data.wagonsResult.kirjeldus1 + " " + data.wagonsResult.vaguni_number);
            //Legacy.debug(data["wagonsResult"]);
            let nrow: MeasurementType = data.wagonsResult;
            nrow.vaguni_number = 0;
            let cnrow: ConvertedMeasurementType = convert_data_row(nrow);

            global.original_grid_data[0] = nrow;
            global.grid_data[0] = cnrow;

            if ($("#wagons_li").hasClass("active")) {
                Legacy.debug("updated current row wagons page: new time");
                //this.make_wagons_page();
                this.make_grid();
            } else if ($("#graph_li").hasClass("active")) {
                Legacy.debug("updated graph page: new time");
                if (global.current_shown_wagon == global.current_wagon) {
                    let status = $("#rawb").hasClass('active');
                    //this.make_wagons_page();
                    this.make_grid();
                    graph.make_graph_page();
                    if (status) graph.raw_toggle();
                }
            }
            // handle error showing
            this.handleError(cnrow.error);
        }
        this.productTransformer = null;
    }

    handleError(error: Array<string>) {
        let alarms = Alarms.getInstance();
        if (error && error.length > 0) {
            Legacy.debug("found err " + error);
            $("#errbar").html(limit_strlen(alarms.process_errstr(error[0]), 190));
        }
    }

    wagoncall(data: WagonsResultType, wagon: number) {
        // Legacy.debug("wagoncall: " + wagon);
        let settings = Settings.getInstance();
        this.productTransformer = new ProductTransformer(SettingsStore.getProductConfig());

        if (data && data.wagonsResult) {
            // Legacy.debug(data.wagonsResult.kirjeldus1 + " " + data.wagonsResult.vaguni_number);
            //Legacy.debug(data["wagonsResult"]);
            data.wagonsResult.vaguni_number = wagon;
            global.original_grid_data[wagon] = data.wagonsResult;
            global.grid_data[wagon] = convert_data_row(global.original_grid_data[wagon]);
        } else {
            // Mingi viga vaguni info laadimisel. Teeme tühjaks:
            global.original_grid_data[wagon] = {};
            global.grid_data[wagon] = {};
        }
        this.wagon_load_count++;
        // Legacy.debug("wagon_load_count: " + this.wagon_load_count);
        if (global.showAsRead) {
            // do not redraw if some other tab active
            if ($("#wagons_li").hasClass("active")) {
                this.make_grid();
            } else if ($("#graph_li").hasClass("active")) {
                //this.make_grid();
            }
        } else {
            if (this.wagon_load_count >= (settings.getWagonCount() - this.min_wagon_urlnr)) {
                Legacy.debug("found enough: " + this.wagon_load_count + " : now drawing");
                // do not redraw if some other tab active
                if ($("#wagons_li").hasClass("active")) {
                    // this.make_wagons_page();
                    this.make_grid();
                } else if ($("#graph_li").hasClass("active")) {
                    //this.make_grid();
                }
            }
        }

        this.productTransformer = null;
    }

    /**
     * Meetod uuendab wagonConf andmed grid'i
     */
    update_wagon_flags() {
        let wagonConf = WagonConf.getInstance();
        for (let i = 0; i < global.grid_data.length; i++) {
            this.turn_flag_onoff(i, "m", wagonConf.isMootmine(i));
            this.turn_flag_onoff(i, "e", wagonConf.isServaotsing(i));
            this.turn_flag_onoff(i, "fe", wagonConf.isForcedServaotsing(i));
            //turn_flag_enabled_disabled(i, "m", !servaotsingOn);
            //turn_flag_enabled_disabled(i, "r", !servaotsingOn && mootmineOn);
            // this.turn_flag_enabled_disabled(i, "r", mootmineOn);
            $("#skeleton" + i).text(wagonConf.getRaamiNr(i) + "");
        }
    }

    /**
     * NB! Funktsioonis on "this" vale?
     * @param y
     */
    measure_btn(y: number) {
        //Legacy.debug("measure_btn "+y);
        let wagonConf = WagonConf.getInstance();
        if (!this.is_flag_enabled(y, "m")) return;

        let turnOn = !wagonConf.isMootmine(y);
        this.turn_flag_onoff(y, "m", turnOn);
        this.turn_flag_enabled_disabled(y, "r", turnOn);
        wagonConf.setMootmine(y, turnOn);
    }

    /**
     * NB! Funktsioonis on "this" vale?
     * @param y
     */
    repeat_btn(y: number) {
        //Legacy.debug("repeat_btn "+y);
        /*
        if (!wagons.is_flag_enabled(y, "r")) return;

        let turnOn = !wagonConf.isKordusmootmine(y);
        this.turn_flag_onoff(y, "r", turnOn);
        wagonConf.setKordusmootmine(y, turnOn);
        */
    }

    edge_btn(y: number) {
        //Legacy.debug("edge_btn "+y);
        let wagonConf = WagonConf.getInstance();
        let turnOn = !wagonConf.isServaotsing(y);
        this.turn_flag_onoff(y, "e", turnOn);
        //turn_flag_enabled_disabled(y, "m", !turnOn);
        //turn_flag_enabled_disabled(y, "r", !turnOn);
        wagonConf.setServaotsing(y, turnOn);
    }

    fedge_btn(y: number) {
        //Legacy.debug("fedge_btn "+y);
        let wagonConf = WagonConf.getInstance();
        let turnOn = !wagonConf.isForcedServaotsing(y);
        this.turn_flag_onoff(y, "fe", turnOn);
        //turn_flag_enabled_disabled(y, "m", !turnOn);
        //turn_flag_enabled_disabled(y, "r", !turnOn);
        wagonConf.setForcedServaotsing(y, turnOn);
    }

    is_flag_enabled(y: number, flag: string) {
        let id;
        if (flag == "e") id = "#edge";
        else if (flag == "m") id = "#measure";
        else id = "#repeat";
        id += y;
        if ($(id).prop('disabled')) return false;
        return true;
    }

    turn_flag_onoff(y: number, flag: string, on: boolean) {
        let id;
        if (flag == "e") id = "#edge";
        else if (flag == "fe") id = "#fedge";
        else if (flag == "m") id = "#measure";
        else id = "#repeat";
        id += y;
        if (on) {
            $(id).removeClass('passive');
            $(id).addClass('active');
        } else {
            $(id).removeClass('active');
            $(id).addClass('passive');
        }
    }

    turn_flag_enabled_disabled(y: number, flag: string, enabled: boolean) {
        let id;
        if (flag == "e") id = "#edge";
        else if (flag == "m") id = "#measure";
        else id = "#repeat";
        id += y;
        if (enabled) $(id).prop('disabled', false);
        else $(id).prop('disabled', true);
    }

    /**
     * Vaguni raami numbri muutmine.
     * NB! Funktsioonis on "this" vale!
     */
    change_skeleton(w: number) {
        let wagonConf = WagonConf.getInstance();
        // Avame popup-akna numbri muutmiseks:
        Popup.ask_input(t("Enter new skeleton number (max 4 characters)"), wagonConf.getRaamiNr(w),
            function (result: ?string) {
                // Kui määramata, siis vajutati cancel:
                if (result == null) return;
                // Salvestame raami numbri serverisse:
                if (result.length > 4) result = result.substring(0, 4);
                $("#skeleton" + w).text(result);
                global.grid_data[w].skeleton = result;
                wagonConf.setRaamiNr(w, result);
            });
    }

    /**
     * Vaguniga seotud toote koodile versiooni valimine
     * NB! Funktsioonis on "this" vale!
     */
    change_code(w: number) {
        let wagonConf = WagonConf.getInstance();
        let drow: ConvertedMeasurementType = Legacy.getDrow(w);
        let baseCode = drow.codeVariant + "";
        let codeVariant = this.getKoodVariant(w);
        bootbox.dialog({
            title: t("Select code variant"),
            message: '<form> <select name="codeVariant" id="codeVariant"><option>' + codeVariant + '</option></select></form>',
            buttons: {
                cancel: {
                    label: "Cancel",
                    className: "btn-default"
                },
                confirm: {
                    label: "OK",
                    className: "btn-primary",
                    callback: function () {
                        let newCode = $("#codeVariant").val();
                        if (newCode != codeVariant) {
                            wagonConf.setKood(w, newCode);
                            this.setGridKood(w, newCode);
                        }
                    }.bind(this)
                },
            }
        });
        $("#codeVariant").selectpicker();

        this.getProductVersions(baseCode, function (data: ProductVersionsType): void {
            let options = "";
            for (let i = 0; i < data.length; i++) {
                let selected = '';
                if (data[i] == codeVariant) selected = ' selected="selected"';
                options += '<option' + selected + '>' + htmlEncode(data[i]) + '</option>\n';
            }
            $("#codeVariant").html(options);
            $("#codeVariant").selectpicker('refresh');
        });
    }

    /**
     * Leiab toote versioonide nimekirja
     *
     * @param kood
     *            Toote kood
     * @param callbackFunc
     *            Funktsioon, mis kutsutakse resultaadiga välja
     */
    getProductVersions(kood: string, callbackFunc: (ProductVersionsType) => void) {
        jsonAjax({
            type: "GET",
            url: AppConfig.BASE_URL + "/productVersions/" + kood,
            success: function (data: ProductVersionsResultType) {
                if (data && data.productVersionsResult && callbackFunc) {
                    callbackFunc(data.productVersionsResult);
                }
            },
            error: function (a, b, c) {
                // show_err(t("Error saving wagon conf"));
            }
        });
    }


    /**
     * Meetod tagastab näidatud gridi rea kohta sellele määratud toote koodi koos variandi infoga
     */
    getKoodVariant(n: IntegerType): string {
        let wagonConf = WagonConf.getInstance();
        let drow: ConvertedMeasurementType = Legacy.getDrow(n);
        if (!drow) return "";
        let codeVariant = (drow.codeVariant == null ? "" : drow.codeVariant) + "";
        if (!codeVariant) return codeVariant;

        // Leiame, kas variant on määratud:
        let wagonCode = wagonConf.getKood(n) + "";
        if (!wagonCode) return codeVariant;
        if (getProductCode(codeVariant) == getProductCode(wagonCode)) return wagonCode;
        return codeVariant;
    }

    setGridKood(n, kood) {
        $("#code" + n).text(kood);
        if (kood != this.getKoodVariant(n)) $("#code" + n).css('color', 'red');
        else $("#code" + n).css('color', null);
    }
}

export default Wagons;
